module.exports = __webpack_public_path__ + "src/assets/img/door_right_color.03263a42.svg";